// extracted by mini-css-extract-plugin
module.exports = {"imgWrapper":"ImageHeader_imgWrapper__VK67X","img":"ImageHeader_img__3k3Qt","selected":"ImageHeader_selected__CpRJV"};